import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { resetPassword } from '../../services/authService';

const Wrap = ({ children }) => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    background: 'linear-gradient(135deg,#1a1430 0%,#0c0816 70%)', fontFamily: "'Montserrat', sans-serif" }}>
    <div style={{ width: '100%', maxWidth: 420, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)',
      borderRadius: 18, padding: 30, backdropFilter: 'blur(14px)', boxShadow: '0 24px 60px rgba(0,0,0,0.45)', textAlign: 'center', color: '#fff' }}>
      {children}
    </div>
  </div>
);
const H = ({ children }) => <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 10 }}>{children}</div>;
const P = ({ children }) => <p style={{ fontSize: 14, color: '#c9bff0', lineHeight: 1.55, marginBottom: 18 }}>{children}</p>;
const Btn = (props) => <button {...props} style={{ width: '100%', padding: 13, border: 'none', borderRadius: 30, cursor: 'pointer',
  background: 'linear-gradient(180deg,#7c4dff,#6d28d9)', color: '#fff', fontSize: 13.5, fontWeight: 700, letterSpacing: 0.5,
  textTransform: 'uppercase', fontFamily: 'inherit', boxShadow: '0 10px 26px -10px rgba(124,77,255,0.7)', opacity: props.disabled ? 0.6 : 1, ...(props.style || {}) }} />;
const inputStyle = { width: '100%', padding: '12px 14px', boxSizing: 'border-box', background: 'rgba(0,0,0,0.3)',
  border: '1px solid rgba(255,255,255,0.15)', borderRadius: 11, color: '#fff', fontSize: 14, outline: 'none', fontFamily: 'inherit', marginBottom: 12 };

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error('Пароль минимум 6 символов');
    if (password !== confirm) return toast.error('Пароли не совпадают');
    setLoading(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      toast.success('Пароль обновлён');
      setTimeout(() => navigate('/'), 1400);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Не удалось сбросить пароль');
    } finally { setLoading(false); }
  };

  if (!token) return (
    <Wrap><H>Ссылка недействительна</H><P>Запросите сброс пароля заново.</P><Btn onClick={() => navigate('/')}>На страницу входа</Btn></Wrap>
  );

  return (
    <Wrap>
      {done ? (
        <><H>Готово ✓</H><P>Пароль обновлён. Перенаправляем на вход…</P></>
      ) : (
        <form onSubmit={submit}>
          <H>Новый пароль</H>
          <P>Придумайте новый пароль для входа.</P>
          <input type="password" style={inputStyle} value={password} onChange={e => setPassword(e.target.value)} placeholder="Новый пароль" />
          <input type="password" style={inputStyle} value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Повторите пароль" />
          <Btn type="submit" disabled={loading}>{loading ? 'Сохранение…' : 'Сохранить пароль'}</Btn>
          <p style={{ marginTop: 14, fontSize: 13 }}><Link to="/" style={{ color: '#b794f6', fontWeight: 600 }}>← Ко входу</Link></p>
        </form>
      )}
    </Wrap>
  );
}
